import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import CardMedia from '@material-ui/core/CardMedia';
import Paper from '@material-ui/core/Paper';
import { Container,Typography } from '@material-ui/core';
import Section from './Section';
import { useCardDataContext } from "./CardDataContext.js";
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { CheckBoxOutlined } from '@material-ui/icons';
import { blogAdmins, blogUrl } from '../util/blogFeaturesSettings';
const useStyles = makeStyles((theme) => ({
  box: {
    border: '1px solid #ccc',
    padding: theme.spacing(2),
    margin: theme.spacing(2),
  },
  section: {
    marginBottom: theme.spacing(3),
  },
  subheading: {
    marginBottom: theme.spacing(1),
  },
  contentSection: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: theme.spacing(2),
  },
  media: {
    width: '100%',
    height: '100%',
    maxHeight:"400px",
    objectFit: 'contain',
    marginBottom: theme.spacing(1),
  },
  addButton: {
    marginRight: theme.spacing(1),
  },
  previewBox: {
    border: '1px solid #ccc',
    padding: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
}));



const CreateBlog = (props) => {
  const classes = useStyles();
  const {updateCardCount}=useCardDataContext();
  const history = useHistory();

  const [blogData, setBlogData] = useState({
    title: '', description: '',coverImage:'',
    sections: [{ id: 1, subheading: '', contentSections: [{ id: 1, type: 'text' }] }],
  });

  //features of quill editor
  const formats = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'indent',
    'link',
    'align',
  ];

  const modules = {
    toolbar: {
      container: [
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['blockquote', 'link'],
        ['align'],
      ],
    },
  };



//functionality associated with Buttons
  const addSection = () => {
    const newId = blogData.sections.length + 1;
    setBlogData((prevData) => ({
      ...prevData,
      sections: [...prevData.sections, { id: newId, subheading: '', contentSections: [{ id: 1, type: 'text' }]}],
    }));
  };

  const removeSection = (sectionId) => {
    setBlogData((prevData) => {
      // Filter out the section to be removed
      const updatedSections = prevData.sections.filter((section) => section.id !== sectionId);

      // Reindex the section ids sequentially starting from 1
      const reindexedSections = updatedSections.map((section, index) => ({
        ...section,
        id: index + 1,
      }));

      // Return the updated data with the reindexed sections
      return {
        ...prevData,
        sections: reindexedSections,
      };
    });
  };

  const addContentSection = (sectionId) => {
    const sectionIndex = blogData.sections.findIndex((section) => section.id === sectionId);
    if (sectionIndex !== -1) {
      const newContentId = blogData.sections[sectionIndex].contentSections.length + 1;
      setBlogData((prevData) => ({
        ...prevData,
        sections: prevData.sections.map((section) =>
          section.id === sectionId
            ? {
                ...section,
                contentSections: [
                  ...section.contentSections,
                  { id: newContentId, type: 'text' },
                ],
              }
            : section
        ),
      }));
    }
  };

  const removeContentSection = (sectionId, contentId) => {
    setBlogData((prevData) => {
      // Find the section index
      const sectionIndex = prevData.sections.findIndex((section) => section.id === sectionId);
  
      // If the section is found
      if (sectionIndex !== -1) {
        // Filter out the content section to be removed
        const updatedContentSections = prevData.sections[sectionIndex].contentSections.filter(
          (content) => content.id !== contentId
        );
  
        // Reindex the content section ids sequentially starting from 1
        const reindexedContentSections = updatedContentSections.map((content, index) => ({
          ...content,
          id: index + 1,
        }));
  
        // Return the updated data with the reindexed content sections
        return {
          ...prevData,
          sections: prevData.sections.map((section) =>
            section.id === sectionId
              ? {
                  ...section,
                  contentSections: reindexedContentSections,
                }
              : section
          ),
        };
      }
  
      // If the section is not found, return the previous data as is
      return prevData;
    });
  };
  

  const toggleContentType = (sectionId, contentId) => {
    setBlogData((prevData) => ({
      ...prevData,
      sections: prevData.sections.map((section) =>
        section.id === sectionId
          ? {
              ...section,
              contentSections: section.contentSections.map((content) =>
                content.id === contentId
                  ? { ...content, type: content.type === 'text' ? 'media' : 'text' }
                  : content
              ),
            }
          : section
      ),
    }));
  };

  const handleSubheadingChange = (sectionId, event) => {
    setBlogData((prevData) => ({
      ...prevData,
      sections: prevData.sections.map((section) =>
        section.id === sectionId ? { ...section, subheading: event.target.value } : section
      ),
    }));
  };

  const handleTitleChange = (event) => {
    setBlogData((prevData) => ({
      ...prevData,
      title: event.target.value,
    }));
  };
  
  const handleDescriptionChange = (event) => {
    setBlogData((prevData) => ({
      ...prevData,
      description: event.target.value,
    }));
  };
  const handleCoverImageChange = (event) => {
    setBlogData((prevData) => ({
      ...prevData,
      coverImage: event.target.value,
    }));
  };


  async function postDataToDB(apiUrl, jsonData) {
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
          // Add any additional headers if needed
        },
        body: JSON.stringify(jsonData),
      });
  
      if (!response.ok) {
        throw new Error(`Error: ${response.status} - ${response.statusText}`);
      }
  
      const data = await response.json();
      console.log('Data posted successfully:', data);
      return data;
    } catch (error) {
      console.error('Error posting data:', error.message);
      return null; // or handle the error in a different way
    }
  }
  

  const handleSubmit = () => {
    const blogObject = {
      title: blogData.title,
      sections: blogData.sections.map((section) => ({
        subheading: section.subheading,
        contentSections: section.contentSections.map((content) => ({
          type: content.type,
          content: content.content,
        })),
      })),
    };
     const postedData=postDataToDB(`${blogUrl}/api/tasks`,blogData)
    //  console.log("This is posted Data:",postedData)
    // Log the JSON object

    updateCardCount((prevCount) => prevCount + 1);
    alert('Data posted successfully!');
    history.push('/blogList'); // Replace '/new-link' with the desired URL

    // console.log('Submitted Blog:', JSON.stringify(blogObject, null, 2));
    // console.log('Submitted Blog:', blogData);
  };
 
  const PreviewSection = ({ section }) => (
    <Paper className={classes.previewBox} marginY={"10px"} style={{ borderBottom: "1px solid silver" }}>
      <Typography  gutterBottom style={{ fontFamily: "Chakra Petch, sans-serif", fontSize: "30px" }}>
        {section.subheading}
      </Typography>
      {section.contentSections.map((content) => (
        <div key={content.id} className={classes.contentSection}>
          {content.type === 'text' ? (
            <Typography
              style={{ 
                fontFamily: "Chakra Petch, sans-serif", 
                fontSize: "25px",
                whiteSpace: 'pre-line', // Ensure that text wraps to a new line
              }}
              dangerouslySetInnerHTML={{
                __html: content.content ? content.content.replace(/\n/g, '<br>') : 'Content is undefined'
              }}
            />
          ) : (
            <div>
              <CardMedia
                className={classes.media}
                component="img"
                style={{ width: '100%', minWidth: '100%', maxHeight: "500px", objectFit: 'contain', borderRadius: '20px' }}
                alt="Media"
                image={content.content}
              />
            </div>
          )}
        </div>
      ))}
    </Paper>
  );
  

  return (
    <Section><Container>    <Box>


<Box className={classes.box}>
      <Typography variant="h5" gutterBottom>
        Create a New Blog
      </Typography>


      <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '6px',
        borderRadius: '10px',
        padding: '1.25rem 1.25rem',
        border: '1px solid #1595a9',
        color: '#117b8c',
        width: '100%',
        background: 'rgba(23, 162, 184, 0.2)',
      }}
    >
      <Typography variant="subtitle1" style={{ fontSize: '12px' }}>
        <CheckBoxOutlined style={{ color: '#117b8c', fontSize: '12px' }} />The Title,Descripiton and CoverImage Url are required field for thumbnail of Blog.
      </Typography>
      <Typography variant="subtitle1" style={{ fontSize: '12px' }}>
        <CheckBoxOutlined style={{ color: '#117b8c', fontSize: '12px' }} /> To Add Content to the Blog first click "Add New Section" and then start inserting text in editor or images (by pasting url)
      </Typography>
      <Typography variant="subtitle1" style={{ fontSize: '12px' }}>
        <CheckBoxOutlined style={{ color: '#117b8c', fontSize: '12px' }} /> Each new subheading will be mentioned in the "Table of Content" section of the blog.
      </Typography>
    </Box>

      <TextField
        style={{ height: 'fit-content' }}
        label="Blog Title (Required)"
        fullWidth
        margin="normal"
        value={blogData.title}
        onChange={handleTitleChange}
      />









      <TextField
        style={{ height: 'fit-content' }}
        label="Blog Description (required)"
        fullWidth
        margin="normal"
        value={blogData.description}
        onChange={handleDescriptionChange}
      />

<CardMedia
  className={classes.media}
  component="img"
  alt="Cover Image"
  image={blogData.coverImage}
/>

<TextField
  label="Cover Image Url"
  fullWidth
  variant="outlined"
  style={{ height: 'fit-content' }}
  value={blogData.coverImage}
  onChange={handleCoverImageChange}
/>
      {blogData.sections.map((section) => (
        <div key={section.id} className={classes.section}>
          <TextField
            label="Subheading"
            fullWidth
            style={{ height: 'fit-content' }}
            margin="normal"
            value={section.subheading}
            onChange={(e) => handleSubheadingChange(section.id, e)}
            className={classes.subheading}
          />

          {section.contentSections.map((content) => (
            <div key={content.id} className={classes.contentSection}>
                {content.type === 'text' ? (
                <ReactQuill
                  value={content.content}
                  onChange={(text) =>
                    setBlogData((prevData) => ({
                      ...prevData,
                      sections: prevData.sections.map((s) =>
                        s.id === section.id
                          ? {
                              ...s,
                              contentSections: s.contentSections.map((c) =>
                                c.id === content.id ? { ...c, content: text } : c
                              ),
                            }
                          : s
                      ),
                    }))
                  }
                  modules={modules}
                  formats={formats}
                />
              ) :
               (
                <div>
                  <CardMedia
                    className={classes.media}
                    alt="Media"
                    image={content.content}
                  />
                  <TextField
                    label="Image URL"
                    fullWidth
                    variant="outlined"
                    style={{ height: 'fit-content' }}
                    value={content.content}
                    onChange={(e) =>
                      setBlogData((prevData) => ({
                        ...prevData,
                        sections: prevData.sections.map((s) =>
                          s.id === section.id
                            ? {
                                ...s,
                                contentSections: s.contentSections.map((c) =>
                                  c.id === content.id ? { ...c, content: e.target.value } : c
                                ),
                              }
                            : s
                        ),
                      }))
                    }
                  />
                </div>
              )}







              <Box style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                <Button
                  variant="outlined"
                  color="primary"
                  fullWidth
                  onClick={() => toggleContentType(section.id, content.id)}
                  className={classes.addButton}
                >
                  {content.type === 'text' ? 'Add Image ' : 'Add Text'}
                </Button>
                <Button
                  variant="outlined"
                  fullWidth
                  color="secondary"
                  onClick={() => removeContentSection(section.id, content.id)}
                >
                  Remove Sub-Section
                </Button>
              </Box>
            </div>
          ))}

  <Button
            variant="contained"
            color="primary"
            onClick={() => addContentSection(section.id)}
            className={classes.addButton}
          >
            Add Sub-Section
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => removeSection(section.id)}
          >
            Remove Section
          </Button>
        </div>
      ))}

      <Button
        variant="contained"
        color="primary"
        onClick={addSection}
        className={classes.addButton}
      >
        Add New Section
      </Button>
      <Button variant="contained" color="primary" onClick={handleSubmit}>
        Create Blog
      </Button>
    </Box>





      {blogData.sections.map((section) => (
        <PreviewSection key={section.id} section={section} />
      ))}
    </Box>
    </Container>
    </Section>
  );
};

export default CreateBlog;
